import Slider from "components/DesignSystem/Slider/Slider";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { ThreadChat } from "./ThreadChat";

type ThreadSliderProps = {
  open: boolean;
  onClose: () => void;
  threadMessage: any;
};

const ThreadSliderComponent = ({
  open,
  onClose,
  threadMessage,
}: ThreadSliderProps) => {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Slider.Root open={open} onOpenChange={handleClose}>
      <Slider.Content open={open} className="t-overflow-hidden">
        <ThreadChat
          open={open}
          onClose={handleClose}
          threadMessage={threadMessage}
          headerDescription="Your tax health, at a glance."
          askForAdminReview
        />
      </Slider.Content>
    </Slider.Root>
  );
};

// Export with simple comparison
export const ThreadSlider = memo(
  ThreadSliderComponent,
  (prevProps, nextProps) => {
    return (
      prevProps.open === nextProps.open &&
      prevProps.threadMessage?.id === nextProps.threadMessage?.id &&
      prevProps.threadMessage?.custom_data?.ai_agent_validation
        ?.thread_feedback_rating ===
        nextProps.threadMessage?.custom_data?.ai_agent_validation
          ?.thread_feedback_rating
    );
  }
);
